// Mutation hook for creating a new skill (POST /skills). Invalidates the
// skills list so the browse widget picks up the new row.

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { skillKeys } from '@/entities/skill';
import { createSkill, type CreateSkillInput } from '@/services/skills';

export function useCreateSkill() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (input: CreateSkillInput) => createSkill(input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: skillKeys.list() });
    },
  });
  return {
    createSkill: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
  };
}
